module.exports = __webpack_public_path__ + "media/flags/ru-764a16d2.svg";